import { default as energy_45green_45practicesYKaweJPQKoMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue?macro=true";
import { default as fun_45part_45journeyiAoF5bNfQqMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue?macro=true";
import { default as homesafe_45colorado_45master_45builderXbkK8IdERPMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue?macro=true";
import { default as indexp1IAPh0ThOMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/index.vue?macro=true";
import { default as our_45teamWjiy2rJruwMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue?macro=true";
import { default as preferred_45lenderpJmsxLpIO3Meta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue?macro=true";
import { default as realtor_45resourcesoarkd0OhzMMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue?macro=true";
import { default as _91post_9397yLqPIdCOMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/blog/[post].vue?macro=true";
import { default as indexItzCV8GQJtMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue?macro=true";
import { default as indexRFBp8tF905Meta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/blog/index.vue?macro=true";
import { default as _91_46_46_46slug_93H4A8JXvTXGMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue?macro=true";
import { default as index9gMwpjEXFaMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue?macro=true";
import { default as central_45park_45special_45offer6geZWsSekcMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue?macro=true";
import { default as ask_45a_45questionVIggvHenJnMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue?macro=true";
import { default as career_45opportunitiesrzWDXPsdsUMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue?macro=true";
import { default as faq7CunSURL2tMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue?macro=true";
import { default as homeowner_45resourceshsDS9unTnfMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue?macro=true";
import { default as indexAZEuJBCh1SMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue?macro=true";
import { default as our_45locationsWATdkE7F8pMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue?macro=true";
import { default as current_45offersf4HsTnMXjeMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/current-offers.vue?macro=true";
import { default as indexToANlBzKHvMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue?macro=true";
import { default as indexwWzfUDAlQVMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/events/index.vue?macro=true";
import { default as indexrFXhJGN2VPMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue?macro=true";
import { default as indexpChw7bswDAMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue?macro=true";
import { default as indexmsOzOsG6jzMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue?macro=true";
import { default as indexnisEXFC3z8Meta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue?macro=true";
import { default as indexwPjm3lSyzhMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/index.vue?macro=true";
import { default as knolls_45hoa_45informationSdRGylIc31Meta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue?macro=true";
import { default as land_45acquisitionjso6Tb7BNAMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue?macro=true";
import { default as brents_45placeQRKq6T7lmeMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue?macro=true";
import { default as experience_45lower_45maintenance8mDyTruELoMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue?macro=true";
import { default as _91testimonial_93UzJbXiNj1BMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue?macro=true";
import { default as index6H8GkkWLfoMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue?macro=true";
import { default as indexL1JBhI05o1Meta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue?macro=true";
import { default as whats_45lifefullnessVV43wi3Go1Meta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue?macro=true";
import { default as _91_46_46_46slug_93OkTnFRHSV8Meta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue?macro=true";
import { default as my_45favoritesLudyIFxJV8Meta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/my-favorites.vue?macro=true";
import { default as new_45home_45searchrCJuPFipNNMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/new-home-search.vue?macro=true";
import { default as easyhouse5gNW7Y3slBMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue?macro=true";
import { default as limitededition8gAiBF1N8KMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue?macro=true";
import { default as wee_45cottageRAydw3tLAwMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue?macro=true";
import { default as indexWKwg9W3goNMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue?macro=true";
import { default as our_45neighborhoods9L4E2xieRzMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue?macro=true";
import { default as partner_45with_45usYCY9YPVhShMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue?macro=true";
import { default as privacytermsg09tpZSVlCMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/privacyterms.vue?macro=true";
import { default as sandboxSA7ApMweFtMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/sandbox.vue?macro=true";
import { default as _91_46_46_46slug_930v0SIdITtcMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue?macro=true";
import { default as component_45stubBNcq3GLuVaMeta } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stubBNcq3GLuVa } from "/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: energy_45green_45practicesYKaweJPQKoMeta?.name ?? "about-us-energy-green-practices",
    path: energy_45green_45practicesYKaweJPQKoMeta?.path ?? "/about-us/energy-green-practices",
    meta: energy_45green_45practicesYKaweJPQKoMeta || {},
    alias: energy_45green_45practicesYKaweJPQKoMeta?.alias || [],
    redirect: energy_45green_45practicesYKaweJPQKoMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue").then(m => m.default || m)
  },
  {
    name: fun_45part_45journeyiAoF5bNfQqMeta?.name ?? "about-us-fun-part-journey",
    path: fun_45part_45journeyiAoF5bNfQqMeta?.path ?? "/about-us/fun-part-journey",
    meta: fun_45part_45journeyiAoF5bNfQqMeta || {},
    alias: fun_45part_45journeyiAoF5bNfQqMeta?.alias || [],
    redirect: fun_45part_45journeyiAoF5bNfQqMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue").then(m => m.default || m)
  },
  {
    name: homesafe_45colorado_45master_45builderXbkK8IdERPMeta?.name ?? "about-us-homesafe-colorado-master-builder",
    path: homesafe_45colorado_45master_45builderXbkK8IdERPMeta?.path ?? "/about-us/homesafe-colorado-master-builder",
    meta: homesafe_45colorado_45master_45builderXbkK8IdERPMeta || {},
    alias: homesafe_45colorado_45master_45builderXbkK8IdERPMeta?.alias || [],
    redirect: homesafe_45colorado_45master_45builderXbkK8IdERPMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue").then(m => m.default || m)
  },
  {
    name: indexp1IAPh0ThOMeta?.name ?? "about-us",
    path: indexp1IAPh0ThOMeta?.path ?? "/about-us",
    meta: indexp1IAPh0ThOMeta || {},
    alias: indexp1IAPh0ThOMeta?.alias || [],
    redirect: indexp1IAPh0ThOMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45teamWjiy2rJruwMeta?.name ?? "about-us-our-team",
    path: our_45teamWjiy2rJruwMeta?.path ?? "/about-us/our-team",
    meta: our_45teamWjiy2rJruwMeta || {},
    alias: our_45teamWjiy2rJruwMeta?.alias || [],
    redirect: our_45teamWjiy2rJruwMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue").then(m => m.default || m)
  },
  {
    name: preferred_45lenderpJmsxLpIO3Meta?.name ?? "about-us-preferred-lender",
    path: preferred_45lenderpJmsxLpIO3Meta?.path ?? "/about-us/preferred-lender",
    meta: preferred_45lenderpJmsxLpIO3Meta || {},
    alias: preferred_45lenderpJmsxLpIO3Meta?.alias || [],
    redirect: preferred_45lenderpJmsxLpIO3Meta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue").then(m => m.default || m)
  },
  {
    name: realtor_45resourcesoarkd0OhzMMeta?.name ?? "about-us-realtor-resources",
    path: realtor_45resourcesoarkd0OhzMMeta?.path ?? "/about-us/realtor-resources",
    meta: realtor_45resourcesoarkd0OhzMMeta || {},
    alias: realtor_45resourcesoarkd0OhzMMeta?.alias || [],
    redirect: realtor_45resourcesoarkd0OhzMMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue").then(m => m.default || m)
  },
  {
    name: _91post_9397yLqPIdCOMeta?.name ?? "blog-post",
    path: _91post_9397yLqPIdCOMeta?.path ?? "/blog/:post()",
    meta: _91post_9397yLqPIdCOMeta || {},
    alias: _91post_9397yLqPIdCOMeta?.alias || [],
    redirect: _91post_9397yLqPIdCOMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/blog/[post].vue").then(m => m.default || m)
  },
  {
    name: indexItzCV8GQJtMeta?.name ?? "blog-category-category",
    path: indexItzCV8GQJtMeta?.path ?? "/blog/category/:category()",
    meta: indexItzCV8GQJtMeta || {},
    alias: indexItzCV8GQJtMeta?.alias || [],
    redirect: indexItzCV8GQJtMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexRFBp8tF905Meta?.name ?? "blog",
    path: indexRFBp8tF905Meta?.path ?? "/blog",
    meta: indexRFBp8tF905Meta || {},
    alias: indexRFBp8tF905Meta?.alias || [],
    redirect: indexRFBp8tF905Meta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93H4A8JXvTXGMeta?.name ?? "campaigns-slug",
    path: _91_46_46_46slug_93H4A8JXvTXGMeta?.path ?? "/campaigns/:slug(.*)*",
    meta: _91_46_46_46slug_93H4A8JXvTXGMeta || {},
    alias: _91_46_46_46slug_93H4A8JXvTXGMeta?.alias || [],
    redirect: _91_46_46_46slug_93H4A8JXvTXGMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index9gMwpjEXFaMeta?.name ?? "campaigns",
    path: index9gMwpjEXFaMeta?.path ?? "/campaigns",
    meta: index9gMwpjEXFaMeta || {},
    alias: index9gMwpjEXFaMeta?.alias || [],
    redirect: index9gMwpjEXFaMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: central_45park_45special_45offer6geZWsSekcMeta?.name ?? "central-park-special-offer",
    path: central_45park_45special_45offer6geZWsSekcMeta?.path ?? "/central-park-special-offer",
    meta: central_45park_45special_45offer6geZWsSekcMeta || {},
    alias: central_45park_45special_45offer6geZWsSekcMeta?.alias || [],
    redirect: central_45park_45special_45offer6geZWsSekcMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue").then(m => m.default || m)
  },
  {
    name: ask_45a_45questionVIggvHenJnMeta?.name ?? "contact-us-ask-a-question",
    path: ask_45a_45questionVIggvHenJnMeta?.path ?? "/contact-us/ask-a-question",
    meta: ask_45a_45questionVIggvHenJnMeta || {},
    alias: ask_45a_45questionVIggvHenJnMeta?.alias || [],
    redirect: ask_45a_45questionVIggvHenJnMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue").then(m => m.default || m)
  },
  {
    name: career_45opportunitiesrzWDXPsdsUMeta?.name ?? "contact-us-career-opportunities",
    path: career_45opportunitiesrzWDXPsdsUMeta?.path ?? "/contact-us/career-opportunities",
    meta: career_45opportunitiesrzWDXPsdsUMeta || {},
    alias: career_45opportunitiesrzWDXPsdsUMeta?.alias || [],
    redirect: career_45opportunitiesrzWDXPsdsUMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue").then(m => m.default || m)
  },
  {
    name: faq7CunSURL2tMeta?.name ?? "contact-us-faq",
    path: faq7CunSURL2tMeta?.path ?? "/contact-us/faq",
    meta: faq7CunSURL2tMeta || {},
    alias: faq7CunSURL2tMeta?.alias || [],
    redirect: faq7CunSURL2tMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue").then(m => m.default || m)
  },
  {
    name: homeowner_45resourceshsDS9unTnfMeta?.name ?? "contact-us-homeowner-resources",
    path: homeowner_45resourceshsDS9unTnfMeta?.path ?? "/contact-us/homeowner-resources",
    meta: homeowner_45resourceshsDS9unTnfMeta || {},
    alias: homeowner_45resourceshsDS9unTnfMeta?.alias || [],
    redirect: homeowner_45resourceshsDS9unTnfMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue").then(m => m.default || m)
  },
  {
    name: indexAZEuJBCh1SMeta?.name ?? "contact-us",
    path: indexAZEuJBCh1SMeta?.path ?? "/contact-us",
    meta: indexAZEuJBCh1SMeta || {},
    alias: indexAZEuJBCh1SMeta?.alias || [],
    redirect: indexAZEuJBCh1SMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45locationsWATdkE7F8pMeta?.name ?? "contact-us-our-locations",
    path: our_45locationsWATdkE7F8pMeta?.path ?? "/contact-us/our-locations",
    meta: our_45locationsWATdkE7F8pMeta || {},
    alias: our_45locationsWATdkE7F8pMeta?.alias || [],
    redirect: our_45locationsWATdkE7F8pMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue").then(m => m.default || m)
  },
  {
    name: current_45offersf4HsTnMXjeMeta?.name ?? "current-offers",
    path: current_45offersf4HsTnMXjeMeta?.path ?? "/current-offers",
    meta: current_45offersf4HsTnMXjeMeta || {},
    alias: current_45offersf4HsTnMXjeMeta?.alias || [],
    redirect: current_45offersf4HsTnMXjeMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/current-offers.vue").then(m => m.default || m)
  },
  {
    name: indexToANlBzKHvMeta?.name ?? "events-event",
    path: indexToANlBzKHvMeta?.path ?? "/events/:event()",
    meta: indexToANlBzKHvMeta || {},
    alias: indexToANlBzKHvMeta?.alias || [],
    redirect: indexToANlBzKHvMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue").then(m => m.default || m)
  },
  {
    name: indexwWzfUDAlQVMeta?.name ?? "events",
    path: indexwWzfUDAlQVMeta?.path ?? "/events",
    meta: indexwWzfUDAlQVMeta || {},
    alias: indexwWzfUDAlQVMeta?.alias || [],
    redirect: indexwWzfUDAlQVMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/events/index.vue").then(m => m.default || m)
  },
  {
    name: indexrFXhJGN2VPMeta?.name ?? "homes-location-community",
    path: indexrFXhJGN2VPMeta?.path ?? "/homes/:location()/:community()",
    meta: indexrFXhJGN2VPMeta || {},
    alias: indexrFXhJGN2VPMeta?.alias || [],
    redirect: indexrFXhJGN2VPMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue").then(m => m.default || m)
  },
  {
    name: indexpChw7bswDAMeta?.name ?? "homes-location-community-models-model",
    path: indexpChw7bswDAMeta?.path ?? "/homes/:location()/:community()/models/:model()",
    meta: indexpChw7bswDAMeta || {},
    alias: indexpChw7bswDAMeta?.alias || [],
    redirect: indexpChw7bswDAMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue").then(m => m.default || m)
  },
  {
    name: indexmsOzOsG6jzMeta?.name ?? "homes-location-community-plans-plan",
    path: indexmsOzOsG6jzMeta?.path ?? "/homes/:location()/:community()/plans/:plan()",
    meta: indexmsOzOsG6jzMeta || {},
    alias: indexmsOzOsG6jzMeta?.alias || [],
    redirect: indexmsOzOsG6jzMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue").then(m => m.default || m)
  },
  {
    name: indexnisEXFC3z8Meta?.name ?? "homes-location-community-qmi-home",
    path: indexnisEXFC3z8Meta?.path ?? "/homes/:location()/:community()/qmi/:home()",
    meta: indexnisEXFC3z8Meta || {},
    alias: indexnisEXFC3z8Meta?.alias || [],
    redirect: indexnisEXFC3z8Meta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue").then(m => m.default || m)
  },
  {
    name: indexwPjm3lSyzhMeta?.name ?? "index",
    path: indexwPjm3lSyzhMeta?.path ?? "/",
    meta: indexwPjm3lSyzhMeta || {},
    alias: indexwPjm3lSyzhMeta?.alias || [],
    redirect: indexwPjm3lSyzhMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/index.vue").then(m => m.default || m)
  },
  {
    name: knolls_45hoa_45informationSdRGylIc31Meta?.name ?? "knolls-hoa-information",
    path: knolls_45hoa_45informationSdRGylIc31Meta?.path ?? "/knolls-hoa-information",
    meta: knolls_45hoa_45informationSdRGylIc31Meta || {},
    alias: knolls_45hoa_45informationSdRGylIc31Meta?.alias || [],
    redirect: knolls_45hoa_45informationSdRGylIc31Meta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue").then(m => m.default || m)
  },
  {
    name: land_45acquisitionjso6Tb7BNAMeta?.name ?? "land-acquisition",
    path: land_45acquisitionjso6Tb7BNAMeta?.path ?? "/land-acquisition",
    meta: land_45acquisitionjso6Tb7BNAMeta || {},
    alias: land_45acquisitionjso6Tb7BNAMeta?.alias || [],
    redirect: land_45acquisitionjso6Tb7BNAMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue").then(m => m.default || m)
  },
  {
    name: brents_45placeQRKq6T7lmeMeta?.name ?? "lifestyle-brents-place",
    path: brents_45placeQRKq6T7lmeMeta?.path ?? "/lifestyle/brents-place",
    meta: brents_45placeQRKq6T7lmeMeta || {},
    alias: brents_45placeQRKq6T7lmeMeta?.alias || [],
    redirect: brents_45placeQRKq6T7lmeMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue").then(m => m.default || m)
  },
  {
    name: experience_45lower_45maintenance8mDyTruELoMeta?.name ?? "lifestyle-experience-lower-maintenance",
    path: experience_45lower_45maintenance8mDyTruELoMeta?.path ?? "/lifestyle/experience-lower-maintenance",
    meta: experience_45lower_45maintenance8mDyTruELoMeta || {},
    alias: experience_45lower_45maintenance8mDyTruELoMeta?.alias || [],
    redirect: experience_45lower_45maintenance8mDyTruELoMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue").then(m => m.default || m)
  },
  {
    name: _91testimonial_93UzJbXiNj1BMeta?.name ?? "lifestyle-reviews-testimonial",
    path: _91testimonial_93UzJbXiNj1BMeta?.path ?? "/lifestyle/reviews/:testimonial()",
    meta: _91testimonial_93UzJbXiNj1BMeta || {},
    alias: _91testimonial_93UzJbXiNj1BMeta?.alias || [],
    redirect: _91testimonial_93UzJbXiNj1BMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue").then(m => m.default || m)
  },
  {
    name: index6H8GkkWLfoMeta?.name ?? "lifestyle-reviews-category-category",
    path: index6H8GkkWLfoMeta?.path ?? "/lifestyle/reviews/category/:category()",
    meta: index6H8GkkWLfoMeta || {},
    alias: index6H8GkkWLfoMeta?.alias || [],
    redirect: index6H8GkkWLfoMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexL1JBhI05o1Meta?.name ?? "lifestyle-reviews",
    path: indexL1JBhI05o1Meta?.path ?? "/lifestyle/reviews",
    meta: indexL1JBhI05o1Meta || {},
    alias: indexL1JBhI05o1Meta?.alias || [],
    redirect: indexL1JBhI05o1Meta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: whats_45lifefullnessVV43wi3Go1Meta?.name ?? "lifestyle-whats-lifefullness",
    path: whats_45lifefullnessVV43wi3Go1Meta?.path ?? "/lifestyle/whats-lifefullness",
    meta: whats_45lifefullnessVV43wi3Go1Meta || {},
    alias: whats_45lifefullnessVV43wi3Go1Meta?.alias || [],
    redirect: whats_45lifefullnessVV43wi3Go1Meta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93OkTnFRHSV8Meta?.name ?? "marshallfire-slug",
    path: _91_46_46_46slug_93OkTnFRHSV8Meta?.path ?? "/marshallfire/:slug(.*)*",
    meta: _91_46_46_46slug_93OkTnFRHSV8Meta || {},
    alias: _91_46_46_46slug_93OkTnFRHSV8Meta?.alias || [],
    redirect: _91_46_46_46slug_93OkTnFRHSV8Meta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesLudyIFxJV8Meta?.name ?? "my-favorites",
    path: my_45favoritesLudyIFxJV8Meta?.path ?? "/my-favorites",
    meta: my_45favoritesLudyIFxJV8Meta || {},
    alias: my_45favoritesLudyIFxJV8Meta?.alias || [],
    redirect: my_45favoritesLudyIFxJV8Meta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: new_45home_45searchrCJuPFipNNMeta?.name ?? "new-home-search",
    path: new_45home_45searchrCJuPFipNNMeta?.path ?? "/new-home-search",
    meta: new_45home_45searchrCJuPFipNNMeta || {},
    alias: new_45home_45searchrCJuPFipNNMeta?.alias || [],
    redirect: new_45home_45searchrCJuPFipNNMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/new-home-search.vue").then(m => m.default || m)
  },
  {
    name: easyhouse5gNW7Y3slBMeta?.name ?? "our-homes-home-collections-easyhouse",
    path: easyhouse5gNW7Y3slBMeta?.path ?? "/our-homes/home-collections/easyhouse",
    meta: easyhouse5gNW7Y3slBMeta || {},
    alias: easyhouse5gNW7Y3slBMeta?.alias || [],
    redirect: easyhouse5gNW7Y3slBMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue").then(m => m.default || m)
  },
  {
    name: limitededition8gAiBF1N8KMeta?.name ?? "our-homes-home-collections-limitededition",
    path: limitededition8gAiBF1N8KMeta?.path ?? "/our-homes/home-collections/limitededition",
    meta: limitededition8gAiBF1N8KMeta || {},
    alias: limitededition8gAiBF1N8KMeta?.alias || [],
    redirect: limitededition8gAiBF1N8KMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue").then(m => m.default || m)
  },
  {
    name: wee_45cottageRAydw3tLAwMeta?.name ?? "our-homes-home-collections-wee-cottage",
    path: wee_45cottageRAydw3tLAwMeta?.path ?? "/our-homes/home-collections/wee-cottage",
    meta: wee_45cottageRAydw3tLAwMeta || {},
    alias: wee_45cottageRAydw3tLAwMeta?.alias || [],
    redirect: wee_45cottageRAydw3tLAwMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue").then(m => m.default || m)
  },
  {
    name: indexWKwg9W3goNMeta?.name ?? "our-homes",
    path: indexWKwg9W3goNMeta?.path ?? "/our-homes",
    meta: indexWKwg9W3goNMeta || {},
    alias: indexWKwg9W3goNMeta?.alias || [],
    redirect: indexWKwg9W3goNMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue").then(m => m.default || m)
  },
  {
    name: our_45neighborhoods9L4E2xieRzMeta?.name ?? "our-neighborhoods",
    path: our_45neighborhoods9L4E2xieRzMeta?.path ?? "/our-neighborhoods",
    meta: our_45neighborhoods9L4E2xieRzMeta || {},
    alias: our_45neighborhoods9L4E2xieRzMeta?.alias || [],
    redirect: our_45neighborhoods9L4E2xieRzMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue").then(m => m.default || m)
  },
  {
    name: partner_45with_45usYCY9YPVhShMeta?.name ?? "partner-with-us",
    path: partner_45with_45usYCY9YPVhShMeta?.path ?? "/partner-with-us",
    meta: partner_45with_45usYCY9YPVhShMeta || {},
    alias: partner_45with_45usYCY9YPVhShMeta?.alias || [],
    redirect: partner_45with_45usYCY9YPVhShMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue").then(m => m.default || m)
  },
  {
    name: privacytermsg09tpZSVlCMeta?.name ?? "privacyterms",
    path: privacytermsg09tpZSVlCMeta?.path ?? "/privacyterms",
    meta: privacytermsg09tpZSVlCMeta || {},
    alias: privacytermsg09tpZSVlCMeta?.alias || [],
    redirect: privacytermsg09tpZSVlCMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/privacyterms.vue").then(m => m.default || m)
  },
  {
    name: sandboxSA7ApMweFtMeta?.name ?? "sandbox",
    path: sandboxSA7ApMweFtMeta?.path ?? "/sandbox",
    meta: sandboxSA7ApMweFtMeta || {},
    alias: sandboxSA7ApMweFtMeta?.alias || [],
    redirect: sandboxSA7ApMweFtMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/sandbox.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_930v0SIdITtcMeta?.name ?? "videos-slug",
    path: _91_46_46_46slug_930v0SIdITtcMeta?.path ?? "/videos/:slug(.*)*",
    meta: _91_46_46_46slug_930v0SIdITtcMeta || {},
    alias: _91_46_46_46slug_930v0SIdITtcMeta?.alias || [],
    redirect: _91_46_46_46slug_930v0SIdITtcMeta?.redirect,
    component: () => import("/codebuild/output/src2447681710/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue").then(m => m.default || m)
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/about-us/get-our-brochure/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/about-us/in-the-news/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/about-us/realtor-program/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/about-us/what-we-do/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/about-us/who-we-are/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/build-with-us/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/career-opportunities/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/career-opportunities/administrative-assistant-2/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/career-opportunities/director-of-warranty-services/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/career-opportunities/land-development-entitlements-coordinator/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/contact-us/ask-a-question/thank-you/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/contact-us/warranty-services/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/email-signup/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/get-updates/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/get-updates/thank-you/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/how-to-video-library/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/lifestyle/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/locations/lanterns-at-rock-creek/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/locations/silver-leaf/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/locations/wee-cottage-at-north-end-80238/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/locations/wee-cottage-at-rogers-farm/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/locations/west-edge-at-colliers-hill/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/login/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/lost-password/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/maintenance-items/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/marshall-fire-response/thank-you-loi/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/neighborhoods-map-test/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/organism-page/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/our-homes/home-collections/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/our-homes/home-collections/lanterns-series/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/our-homes/home-collections/opportunities-series/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/our-homes/photo-gallery/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/our-homes/photo-gallery/gourmet-kitchens/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/our-homes/photo-gallery/home-offices/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/our-homes/photo-gallery/living-rooms/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/our-homes/photo-gallery/outdoor-living-spaces/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/our-homes/photo-gallery/relaxing-master-suites/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/register/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/reset-password/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/resources-lower-maintenance/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/style-guide/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  },
  {
    name: component_45stubBNcq3GLuVaMeta?.name ?? undefined,
    path: component_45stubBNcq3GLuVaMeta?.path ?? "/warranty-service-request/",
    meta: component_45stubBNcq3GLuVaMeta || {},
    alias: component_45stubBNcq3GLuVaMeta?.alias || [],
    redirect: component_45stubBNcq3GLuVaMeta?.redirect,
    component: component_45stubBNcq3GLuVa
  }
]